import React, { useEffect } from 'react';
import Joyride, { STATUS } from 'react-joyride';
import { useHelp } from '../context/HelpContext';
import './HelpTour.css';

/**
 * Help Tour Component
 * Provides guided tours using react-joyride
 */
const HelpTour = ({ steps, tourName, continuous = true, showProgress = true }) => {
  const { tourRunning, currentTour, stopTour } = useHelp();
  const [run, setRun] = React.useState(false);

  useEffect(() => {
    // Start tour if it matches the current tour name
    if (tourRunning && currentTour === tourName) {
      setRun(true);
    } else {
      setRun(false);
    }
  }, [tourRunning, currentTour, tourName]);

  const handleJoyrideCallback = (data) => {
    const { status } = data;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRun(false);
      stopTour();
    }
  };

  if (!steps || steps.length === 0) {
    return null;
  }

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={continuous}
      showProgress={showProgress}
      showSkipButton={true}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: '#2196f3',
          zIndex: 10000,
        },
        tooltip: {
          borderRadius: 8,
        },
        buttonNext: {
          backgroundColor: '#2196f3',
          fontSize: '14px',
          padding: '8px 16px',
        },
        buttonBack: {
          color: '#666',
          fontSize: '14px',
          padding: '8px 16px',
        },
        buttonSkip: {
          color: '#666',
          fontSize: '14px',
        },
      }}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Finish',
        next: 'Next',
        skip: 'Skip',
      }}
    />
  );
};

export default HelpTour;

